import * as React from 'react';

interface IAuthUserdata {
  id: number;
  name: string;
  email: string;
  roles: string[];
  rights: string[];
  // Retained (always empty) so legacy call sites compile; authentication is now
  // carried by the Bearer token via the axios interceptor in App.tsx.
  access_token: string;
}

interface IAuth extends IAuthUserdata {
  signout: () => void;
  // Opens Keycloak's hosted account console (manage password/email/2FA).
  accountManagement: () => void;
  hasRight: (right: string | boolean) => boolean;
}

const AuthContext = React.createContext<IAuth>({
  id: null,
  name: null,
  email: null,
  roles: [],
  rights: [],
  access_token: '',
  signout: () => {},
  accountManagement: () => {},
  hasRight: () => false
});

export { AuthContext, IAuth, IAuthUserdata }
